import { useContext, useEffect } from 'react';
import { useLoaderData } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import { GlobalContext } from '../../../library/Core/GlobalContext';
import smartReducer from '../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../library/Core/SmartTypes';
import { SmartContext } from '../../../library/Core/SmartContext';
import DebugBarControl from '../../../library/SimpleControls/DebugBarControl';
import Layout from './Layout';
import ConversionsReportGrid from './ConversionsReportGrid';
import SmartContextPage from '../../../library/Core/SmartContextPage';

const ConversionsReport = () => {
    const { globalState } = useContext(GlobalContext);

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {},
    } as any);

    const { formConfig, data, internal, routeInfo } = useLoaderData() as State;

     useEffect(() => {
        const domain = new Map([...globalState.domain]);
        const timer = setTimeout(() => {
            dispatch({
                type: 'DATA_INIT',
                payload: { formConfig, data, domain, internal, routeInfo },
            });
        }, 0);
        return () => clearTimeout(timer);
    }, []);

     return (
        <SmartContextPage state={state} dispatch={dispatch}>
            <Layout>
                <ConversionsReportGrid />
            </Layout>
        </SmartContextPage>
    );
};

export default ConversionsReport;
